export default __webpack_public_path__ + "static/media/brandarrows-background-image-white.c526bfd9.svg";